import { IoCContainer } from '@writefull/core'

export const iocContainer = new IoCContainer()
